module.exports = __webpack_public_path__ + "img/vuma-reach-banner.1d7f4254.jpg";